import BlDropdownAv from './BlDropdownAv.vue'

BlDropdownAv.install = function(Vue) {
  Vue.component(BlDropdownAv.name, BlDropdownAv)
}

export default BlDropdownAv
